import { useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'contact_methods',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({ type: 'discussion' })
  }
}
